import React from 'react';
import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';
import RecordTransition from '../components/RecordTransition';
import { LazyTeamsDisabled } from '../components/TeamError/lazy';
const SearchTeamsError = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecordTransition, {
    name: AnalyticsKeys.ALL_TEAMS_DISABLED
  }), /*#__PURE__*/React.createElement(TrackPageLoad, {
    name: AnalyticsKeys.ALL_TEAMS_DISABLED
  }), /*#__PURE__*/React.createElement(LazyTeamsDisabled, null));
};
export default SearchTeamsError;